export default __webpack_public_path__ + "static/media/AppleStore.b76ac475.png";